<template>
  <div>
    <div class="o-container o-container--full u-pad-top--4 u-mrgn-bottom--4">
      <div class="u-txt--medium u-mrgn-bottom--3">Manajer Investasi</div>
      <div class="u-txt--base u-line-height--20"><EllipsisText :line-num="7" :message="pageDescription" /></div>
    </div>

    <div>
      <div v-for="(content, index) in contentData" :key="index">
        <GeneralItem
          :title="content.name"
          :desc="content.desc"
          :link="baseUrl + content.link_url"
          :info-title="['Tanggal Peluncuran', 'Bank Kustodian']"
          :info-data="[content.launch_date, content.bank]"
        />
      </div>
    </div>

    <div><OtherLinkFooter :other-links="otherLinks" /></div>
  </div>
</template>

<script>
import EllipsisText from 'shared/components/Ellipsis/EllipsisText';
import GeneralItem from 'shared/components/mweb/GeneralItem';
import OtherLinkFooter from 'shared/components/mweb/OtherLinkFooter';

export default {
  name: 'InvestmentManagerIndexMobile',
  components: {
    OtherLinkFooter,
    GeneralItem,
    EllipsisText,
  },
  props: {
    otherLinks: {
      type: Array,
      default: () => [],
    },
    pageDescription: {
      type: String,
      default: '',
    },
    baseUrl: {
      type: String,
      default: '',
    },
    contentData: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
